import { graphql } from "@/gql";

export const updateTrip = graphql(`
  mutation UpdateTrip($id: ID!, $input: UpdateTripInput!) {
    updateTrip(id: $id, input: $input) {
      id
    }
  }
`);
